import React from 'react';
import { useSelector } from 'react-redux'
import { Feedback } from '../feedback';

const Entity = () => { 
    const entity = useSelector((state) => state.asr.entity)
    return (
        <div className='entity mini-card'>         
            <h4>Entity</h4>   
            <div>
            <textarea
                value={entity}
                rows="5" style={{"width": "100%"}} readOnly
                />
            </div>
            <div>
                <Feedback 
                    type = {"entity"} />
            </div>
        </div>
    );
};


export default Entity;